












import Vue from 'vue'
import InstallDevice from '@/components/InstallDevices/InstallDevice.vue'
import UnderlineTextButton from '@/components/Global/UnderlineTextButton.vue'
import RecentEntities from '@/components/InstallDevices/RecentEntities.vue'
import { isMobile } from '@/helpers/mixins'

export default Vue.extend({
  name: 'InstallDevicesMobile',
  components: { RecentEntities, InstallDevice, UnderlineTextButton },
  computed: {
    isMobile () {
      return isMobile()
    }
  },
  data () {
    return {
      replaceDeviceMode: false
    }
  },
  created () {
    if (!this.isMobile || !this.hasPermission('create:entity')) {
      this.$router.push({ path: 'install-devices' })
    }
  }
})
